/* eslint-disable array-callback-return */
/* eslint-disable no-eval */
import React from "react";
import { Link } from "react-router-dom";
// import CSVReader from "react-csv-reader";
import TopBarProgress from "react-topbar-progress-indicator";

import * as XLSX from "xlsx";
import ProgressBar from "react-bootstrap/ProgressBar";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../../components/alert/alert.component";
import axios from "axios";
import { subCategoryNames } from "../../../../actions/subCategory";
import { childSubCategoryNames } from "../../../../actions/childSubCategory";
import {
  bulkProducts,
  bulkProductsUpload,
  etlErrorLogs,
  getAttribute,
} from "../../../../actions/product";
import { getAllStores } from "../../../../actions/store";
import { apiURL } from "../../../../config/default";
const make_cols = (refstr) => {
  let o = [],
    C = XLSX.utils.decode_range(refstr).e.c + 1;
  for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
  return o;
};
class UpdateModelNumber extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      data: "",
      buttonChange: "disabled",
      count: 0,
      getAllStores: [],
      brand: "",
      image: "",
      attributes: [],
      attributeNotFound: [],
      enableButton: false,
      dataUploading: false,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    this.setState({
      enableButton: true,
    });
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({ loading: false });
        this.fileData();
      }
    }, 1000);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const brandIsSelected = this.state.brand !== "";
    const fileIsSelected =
      prevState.data !== this.state.data || this.state.data !== "";
    if (fileIsSelected && brandIsSelected && this.state.enableButton === true) {
      this.setState({
        enableButton: false,
      });
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }
  attributeIdGetter = (name) => {
    // eslint-disable-next-line no-unused-vars
    let nn = name;
    if (
      name.includes("Style") &&
      name !== "Revers Side Style" &&
      name !== "Handle Style"
    ) {
      name = name.substring(0, 5);
    }
    if (name.length < 9 && name.includes("Finish")) {
      name = name.substring(0, 6);
    }
    if (
      name.includes("Material Type") &&
      name !== "Material Type Front" &&
      name !== "Material Type Back"
    ) {
      let size = name.length;
      name = name.substring(0, size - 1);
    }
    if (name.includes("Item Pattern")) {
      let size = name.length;
      name = name.substring(0, size - 1);
    }
    var id = this.state.attributes.find(function (o) {
      return o.name === name.trim();
    });
    if (id && id._id) {
      return id._id;
    } else {
      this.setState({
        attributeNotFound: [...this.state.attributeNotFound, name],
      });
    }
  };
  attributeNameGetter = (attributeId) => {
    var attributeName = this.state.attributes.find(function (o) {
      return o._id === attributeId.trim();
    });
    if (attributeName && attributeName.name) {
      return attributeName.name;
    }
  };

  fileData = async () => {
    this.setState({ buttonChange: "disabled" });
    const response = await this.props.getAllStores();

    if (response) {
      this.setState({
        getAllStores: response.data,
        buttonChange: "",
      });
    }
  };

  handleFile = (file) => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 0,
        blankrows: false,
        defval: null,
        range: 0,
      });

      this.setState({
        buttonChange: "",
        data: data,
        cols: make_cols(ws["!ref"]),
      });
    };

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };
  exportFile() {
    /* convert state to workbook */
    const ws = XLSX.utils.aoa_to_sheet(this.state.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "sheetjs.xlsx");
  }

  getEtlInventory = async (productItems) => {
    try {
      const res = await axios.post(`${apiURL}admin/update-model-numbers`, {
        brand: this.state.brand,
        ...productItems,
      });
      console.log("response value is : ", res?.data);
      return res;
    } catch (err) {
      console.log(err);
    }
  };

  handleInventoryFile = async (data) => {
    this.setState({
      buttonChange: "disabled",
      loading: true,
      dataUploading: true,
    });
    let dataTosend = [];
    // Check if data is defined and not null
    if (data) {
      dataTosend = data.map((item) => {
        const { oldModelNumber, newModelNumber } = item;
        return {
          newModelNumber,
          oldModelNumber,
        };
      });
    }

    let len = data.length;
    for (let index1 = 0; index1 < Math.ceil(len / 50); index1++) {
      const thousandJson = dataTosend.splice(0, 50);

      this.setState({ dataUploading: true, loading: true });
      try {
        const res = await this.getEtlInventory({
          products: thousandJson,
        });

        if (res.status === 200) {
          let counter = this.state.count + thousandJson.length;
          console.log(res.status, counter);
          this.setState({ count: counter });

          this.setState({ dataUploading: false, loading: false });
        }
      } catch (err) {
        this.setState({ dataUploading: false });
      }
    }
  };

  _submitHandler = async () => {
    const { data, brand } = this.state;
    if (brand) {
      this.handleInventoryFile(data);
    } else {
      toast.error(`Please Select Brand`, { containerId: "B" });
    }
  };

  _handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        image: file,
      });
    };

    reader.readAsDataURL(file);
  }

  handleRadioChange = (inp) => {
    this.setState({
      isInventoryFile: inp !== "standard",
    });
  };

  render() {
    TopBarProgress.config({
      barThickness: 4,
      barColors: {
        0: "rgb(51, 201, 45, .7)",
        ".3": "rgb(255, 77, 107, .7)",
        "1.0": "rgb(200, 125, 255, .7)",
      },
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, .5)",
    });
    return (
      <div className="container-scroller">
        {this.state.loading && <TopBarProgress />}

        <ToastContainer
        stacked 
          enableMultiContainer
          containerId={"B"}
          // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
        />

        <div className="page-header">
          <h3 className="page-title" style={{ fontSize: 30 }}>
            {" "}
            Update Model Number
          </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/admin/products">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Update Model Number
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div
              className="card p-0"
              style={{
                border: "1px solid #dcdcdc",
              }}
            >
              <div className="card-body p-0">
                <h4
                  className="card-title"
                  style={{
                    color: "#4c4d5a",
                    borderBottom: "1px solid #dcdcdc",
                    background: "#f6f6f6",
                    textShadow: "0 -1px 0 rgba(50,50,50,0)",
                    padding: 12,
                  }}
                >
                  Update Model Number
                </h4>
                <Alert />

                <form className="forms-sample p-2">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }} htmlFor="brand">
                      1: Select Brand
                    </label>
                    <select
                      className="ml-2 form-control form-control-sm"
                      id="brand"
                      style={{ cursor: "pointer" }}
                      onChange={(e) => {
                        this.setState({ brand: e.target.value });
                      }}
                    >
                      <option>choose</option>
                      {this.state.getAllStores &&
                        this.state.getAllStores.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.fullName}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <div>
                      <label style={{ fontWeight: "bold" }}>
                        2: CSV File upload
                      </label>
                    </div>

                    <div className="input-group  pl-2 col-xs-12">
                      <DragDropFile handleFile={this.handleFile}>
                        <div className="row">
                          <div className="col-xs-12">
                            <DataInput handleFile={this.handleFile} />
                          </div>
                        </div>
                      </DragDropFile>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      {this.state.loading && this.state.loading === true ? (
                        <div className="text-center">
                          <ProgressBar
                            animated
                            now={this.state.count}
                            max={this.state.data.length}
                          />
                          <h5>
                            You have added {` ${this.state.count} `} products
                            proceeded
                          </h5>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <button
                    disabled={
                      this.state.enableButton || this.state.dataUploading
                    }
                    onClick={() => {
                      this._submitHandler();
                    }}
                    type="button"
                    className={`btn btn-primary mr-2 ${this.state.buttonChange}`}
                  >
                    {this.state.dataUploading ? "Updating" : "Submit"}
                  </button>
                </form>
                {this.state.attributeNotFound &&
                  this.state.attributeNotFound.map((item, indx) => (
                    <p key={indx}>{item} attribute not found</p>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* -------------------------------------------------------------------------- */

/*
  Simple HTML5 file drag-and-drop wrapper
  usage: <DragDropFile handleFile={handleFile}>...</DragDropFile>
    handleFile(file:File):void;
*/
class DragDropFile extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }
  suppress(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }
  onDrop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const files = evt.dataTransfer.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <div
        onDrop={this.onDrop}
        onDragEnter={this.suppress}
        onDragOver={this.suppress}
      >
        {this.props.children}
      </div>
    );
  }
}

/*
  Simple HTML5 file input wrapper
  usage: <DataInput handleFile={callback} />
    handleFile(file:File):void;
*/
class DataInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <form className="form-inline">
        <div className="form-group" style={{ marginLeft: "12px" }}>
          <label style={{ fontWeight: "bold" }} htmlFor="file">
            {" "}
          </label>
          <input
            type="file"
            id="file"
            accept={SheetJSFT}
            onChange={this.handleChange}
          />
        </div>
      </form>
    );
  }
}

/* list of supported file types */
const SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
// childCategories.propTypes = {
//   childCategories: PropTypes.func.isRequired,
// };
subCategoryNames.prototype = {
  subCategoryNames: PropTypes.func.isRequired,
};
// mainCategories.prototype = {
//   mainCategories: PropTypes.func.isRequired,
// };
childSubCategoryNames.prototype = {
  childSubCategoryNames: PropTypes.func.isRequired,
};
bulkProducts.prototype = {
  bulkProducts: PropTypes.func.isRequired,
};
bulkProductsUpload.propTypes = {
  bulkProductsUpload: PropTypes.func.isRequired,
};
getAllStores.propTypes = {
  getAllStores: PropTypes.func.isRequired,
};
getAttribute.propTypes = {
  getAttribute: PropTypes.func.isRequired,
};
etlErrorLogs.propTypes = {
  etlErrorLogs: PropTypes.func.isRequired,
};

export default connect(null, {
  subCategoryNames,
  getAttribute,
  childSubCategoryNames,
  bulkProducts,
  getAllStores,
  bulkProductsUpload,
  etlErrorLogs,
})(UpdateModelNumber);
